<template>
  <div class="appointment-records">
    <h2>预约单列表</h2>
    <el-card shadow="hover">
      <template #header>
        <div class="card-header">
          <span>预约单列表</span>
          <el-button type="primary" @click="handleExport">
            <el-icon><Download /></el-icon>
            导出数据
          </el-button>
        </div>
      </template>
      <div class="records-list-content">
        <!-- 搜索区域 -->
        <div class="search-area">
          <el-input
            v-model="searchForm.keyword"
            placeholder="请输入预约订单号、用户昵称、手机号码或商品标题"
            prefix-icon="Search"
            clearable
            class="search-input"
          />
          <div class="search-filters">
            <el-select 
              v-model="searchForm.product_id" 
              placeholder="选择商品" 
              clearable
              filterable
              remote
              :remote-method="handleProductSearch"
              :loading="productsLoading"
              @change="handleSearch"
            >
              <el-option 
                v-for="product in productsList" 
                :key="product.id" 
                :label="product.title" 
                :value="product.id" 
              />
            </el-select>
            <el-button type="primary" @click="handleSearch">
              <el-icon><Search /></el-icon>
              搜索
            </el-button>
          </div>
        </div>

        <!-- 数据表格 -->
        <el-table
          v-loading="loading"
          :data="recordsList"
          stripe
          style="width: 100%"
          class="records-table"
          :row-key="row => row.id"
        >
          <el-table-column label="预约订单号/排名" width="200">
            <template #default="scope">
              <div class="order-rank-column">
                <div class="appointment-no" show-overflow-tooltip>{{ scope.row.appointment_no }}</div>
                <div class="appointment-rank">
                  <el-tag type="success" size="small">第 {{ scope.row.queue_number }} 位</el-tag>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="appointed_at" label="预约时间" width="200">
            <template #default="scope">
              {{ formatDateTime(scope.row.appointed_at) }}
            </template>
          </el-table-column>
          <el-table-column label="用户信息" width="180">
            <template #default="scope">
              <div>
                <div class="user-info-item">昵称：{{ scope.row.user?.nickname || '-' }}</div>
                <div class="user-info-item">手机号：{{ scope.row.user?.phone || '-' }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="商品信息" min-width="300">
            <template #default="scope">
              <div class="product-info">
                {{ scope.row.appointment_product?.title  }}
                <!-- <el-image
                  v-if="scope.row.appointment_product"
                  :src="scope.row.appointment_product.image"
                  fit="cover"
                  style="width: 60px; height: 60px; margin-right: 10px"
                /> -->
                <div v-if="!scope.row.appointment_product" style="width: 60px; height: 60px; margin-right: 10px; background-color: #f5f7fa; display: inline-block; vertical-align: middle;"></div>
                <!-- <div class="product-details">
                  <div class="product-title">{{ scope.row.appointment_product?.title || '-' }}</div>
                  <div class="product-intro">{{ scope.row.appointment_product?.intro || '-' }}</div>
                </div> -->
              </div>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pagination-area">
          <el-pagination
            :current-page="pagination.currentPage"
            :page-size="pagination.pageSize"
            :page-sizes="[10, 20, 50, 100]"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pagination.total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
    </el-card>
  </div>
</template>

<style scoped>
.order-rank-column {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.appointment-no {
  font-size: 14px;
  color: #333;
}

.appointment-rank {
  display: flex;
  align-items: center;
}
</style>

<style scoped>
/* 表格样式优化 */
.records-table {
  font-size: 14px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

/* 订单号/排名列样式 */
.order-rank-column {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.appointment-no {
  font-size: 14px;
  color: #333;
  font-weight: 500;
}

.appointment-rank {
  display: flex;
  align-items: center;
}

/* 商品信息列样式 */
.product-info {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 0;
}

.product-details {
  flex: 1;
  min-width: 0;
}

.product-title {
  font-weight: 500;
  color: #333;
  margin-bottom: 4px;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.product-intro {
  font-size: 12px;
  color: #666;
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

/* 用户信息列样式 */
.user-info-item {
  font-size: 13px;
  color: #666;
  line-height: 1.6;
}

/* 搜索区域样式 */
.search-area {
  display: flex;
  gap: 16px;
  margin-bottom: 20px;
  align-items: center;
  flex-wrap: wrap;
}

.search-input {
  width: 350px;
}

.search-filters {
  display: flex;
  gap: 12px;
  align-items: center;
}

/* 卡片和标题样式 */
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.records-list-content {
  padding: 0;
}

/* 分页区域样式 */
.pagination-area {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
  padding: 16px 0 0;
  border-top: 1px solid #f0f0f0;
}

/* 页面标题样式 */
h2 {
  font-size: 20px;
  font-weight: 600;
  color: #333;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e8e8e8;
}
</style>

<script>
import { ref, reactive, onMounted, watch } from 'vue';
import { ElMessage, ElMessageBox, ElLoading } from 'element-plus';
import { Search, Check, Delete, Download } from '@element-plus/icons-vue';
import { useRoute } from 'vue-router';
import * as appointmentProductApi from '../../api/appointmentProducts';

export default {
  name: 'AppointmentRecords',
  components: {
    Search,
    Check,
    Delete,
    Download
  },
  setup() {
    // 路由实例
    const route = useRoute();
    
    // 搜索表单
    const searchForm = reactive({
      keyword: '',
      product_id: ''
    });

    // 加载状态
    const loading = ref(false);
    // 商品列表加载状态
    const productsLoading = ref(false);

    // 预约记录列表数据
    const recordsList = ref([]);
    // 商品列表数据
    const productsList = ref([]);

    // 分页数据
    const pagination = reactive({
      currentPage: 1,
      pageSize: 10,
      total: 0
    });
    
    // 加载预约商品列表
    const loadProducts = async () => {
      productsLoading.value = true;
      try {
        const response = await appointmentProductApi.fetchAppointmentProductsList({
          page: 1,
          per_page: 100 // 获取足够多的商品
        });
        console.log('商品列表API响应:', response);
        if (response.code === 200) {
          // 检查响应数据结构，适配不同格式
          if (response.data.items) {
            productsList.value = response.data.items;
          } else if (response.data.data) {
            // 适配另一种可能的格式
            productsList.value = response.data.data;
          } else if (Array.isArray(response.data)) {
            // 适配直接返回数组的格式
            productsList.value = response.data;
          } else {
            // 默认格式
            productsList.value = response.data || [];
          }
          console.log('处理后的商品列表:', productsList.value);
        } else {
          ElMessage.error('获取商品列表失败');
        }
      } catch (error) {
        ElMessage.error('获取商品列表失败');
        console.error('获取商品列表失败:', error);
      } finally {
        productsLoading.value = false;
      }
    };

    // 加载预约记录列表
    const loadRecords = async () => {
      loading.value = true;
      try {
        const params = {
          page: pagination.currentPage,
          per_page: pagination.pageSize,
          search: searchForm.keyword,
          product_id: searchForm.product_id
        };
        console.log('请求参数:', params);
        const response = await appointmentProductApi.fetchAllAppointmentRecords(params);
        console.log('API响应:', response);
        console.log('API响应数据结构:', response.data ? Object.keys(response.data) : '无data');
        if (response.code === 200) {
          // 检查响应数据结构，适配不同的返回格式
          if (response.data.items) {
            recordsList.value = response.data.items;
            pagination.total = response.data.pagination?.total || 0;
          } else if (response.data.records) {
            // 适配可能的records格式
            recordsList.value = response.data.records;
            pagination.total = response.data.total || 0;
          } else {
            // 适配直接返回数组的格式
            recordsList.value = Array.isArray(response.data) ? response.data : [];
            pagination.total = recordsList.value.length;
          }
          console.log('recordsList:', recordsList.value);
          console.log('第一条记录:', recordsList.value[0]);
          console.log('第一条记录的appointment_product:', recordsList.value[0]?.appointment_product);
        } else {
          ElMessage.error(`获取预约记录失败: ${response.message || '未知错误'}`);
        }
      } catch (error) {
        ElMessage.error('获取预约记录失败');
        console.error('请求失败:', error);
      } finally {
        loading.value = false;
      }
    };
    
    // 处理路由参数
    watch(() => route.query, async (newQuery) => {
      if (newQuery.product_id) {
        // 检查productsList是否已经加载
        if (productsList.value.length === 0) {
          // 如果productsList为空，先加载商品列表
          await loadProducts();
        }
        
        // 检查productsList中是否包含当前商品
        const productExists = productsList.value.some(product => String(product.id) === String(newQuery.product_id));
        if (!productExists && newQuery.product_name) {
          // 如果productsList中没有当前商品，但URL中传递了product_name，手动添加到productsList
          // 确保ID类型一致（转换为数字类型，与API返回的数据保持一致）
          productsList.value.unshift({
            id: Number(newQuery.product_id),
            title: newQuery.product_name
          });
        }
        
        // 设置商品ID到搜索表单（在商品列表加载完成后）
        // 确保ID类型一致（转换为数字类型）
        searchForm.product_id = Number(newQuery.product_id);
        
        // 当商品ID从URL参数传入时，自动触发搜索
        pagination.currentPage = 1;
        loadRecords();
      }
    }, { immediate: true });
    
    // 商品搜索方法
    const handleProductSearch = async (keyword) => {
      if (!keyword) {
        loadProducts(); // 如果关键词为空，加载所有商品
        return;
      }
      
      productsLoading.value = true;
      try {
        const response = await appointmentProductApi.fetchAppointmentProductsList({
          page: 1,
          per_page: 100,
          search: keyword
        });
        if (response.code === 200) {
          productsList.value = response.data.items;
        } else {
          ElMessage.error('搜索商品失败');
        }
      } catch (error) {
        ElMessage.error('搜索商品失败');
        console.error(error);
      } finally {
        productsLoading.value = false;
      }
    };

    // 搜索预约记录
    const handleSearch = () => {
      pagination.currentPage = 1;
      loadRecords();
    };

    // 格式化日期时间为YYYY-mm-dd HH:ii:ss格式
    const formatDateTime = (dateTime) => {
      if (!dateTime) return '-';
      const date = new Date(dateTime);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    };

    // 确认预约
    const handleConfirm = async (row) => {
      try {
        await ElMessageBox.confirm('确定要确认该预约吗？', '确认提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });
        
        const response = await appointmentProductApi.confirmAppointmentRecord(row.id);
        if (response.code === 200) {
          ElMessage.success('确认成功');
          loadRecords();
        } else {
          ElMessage.error('确认失败');
        }
      } catch (error) {
        if (error !== 'cancel') {
          ElMessage.error('确认失败');
          console.error(error);
        }
      }
    };

    // 取消预约
    const handleCancel = async (row) => {
      try {
        await ElMessageBox.confirm('确定要取消该预约吗？', '取消提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });
        
        const response = await appointmentProductApi.cancelAppointmentRecord(row.id);
        if (response.code === 200) {
          ElMessage.success('取消成功');
          loadRecords();
        } else {
          ElMessage.error('取消失败');
        }
      } catch (error) {
        if (error !== 'cancel') {
          ElMessage.error('取消失败');
          console.error(error);
        }
      }
    };

    // 分页大小变化
    const handleSizeChange = (size) => {
      pagination.pageSize = size;
      loadRecords();
    };

    // 当前页变化
    const handleCurrentChange = (current) => {
      pagination.currentPage = current;
      loadRecords();
    };

    // 导出预约记录数据（异步队列）
    const handleExport = async () => {
      try {
        // 创建导出任务
        const params = {
          search: searchForm.keyword,
          status: searchForm.status
        };
        
        // 调用导出API创建异步任务
        const response = await appointmentProductApi.exportAppointmentRecords(params);
        if (response.code === 200) {
          ElMessage.success('导出任务已创建，正在处理中');
          // 可以跳转到导出记录页面查看进度
          // router.push('/exports');
        } else {
          ElMessage.error('导出任务创建失败');
        }
      } catch (error) {
        console.error('导出任务创建失败', error);
        ElMessage.error('导出任务创建失败');
      }
    };
    
    // 组件挂载时加载数据
    onMounted(() => {
      // 如果URL中没有product_id参数，则加载所有数据
      if (!route.query.product_id) {
        loadProducts(); // 先加载商品列表
        loadRecords(); // 再加载预约记录
      }
      // 如果有product_id参数，watch会自动处理数据加载
    });

    return {
      searchForm,
      loading,
      recordsList,
      pagination,
      productsList,
      productsLoading,
      handleSearch,
      handleProductSearch,
      formatDateTime,
      handleConfirm,
      handleCancel,
      handleSizeChange,
      handleCurrentChange,
      handleExport
    };
  }
};
</script>

<style scoped>
.appointment-records {
  padding: 20px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.search-area {
  margin-bottom: 20px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
}

.search-input {
  width: 400px;
}

.search-filters {
  display: flex;
  gap: 10px;
  align-items: center;
}

.search-filters .el-select {
  width: 150px;
}

.records-list-content {
  margin-top: 20px;
}

.records-table {
  margin-bottom: 20px;
}

.pagination-area {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

.user-info-item {
  font-size: 12px;
  margin-bottom: 4px;
}

.user-info-item:last-child {
  margin-bottom: 0;
}

.product-info {
  display: flex;
  align-items: center;
}

.product-details {
  flex: 1;
  overflow: hidden;
}

.product-title {
  font-size: 13px;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 4px;
}

.product-intro {
  font-size: 12px;
  color: #606266;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>